// Define manual path to service mappings
export const PATH_TO_SERVICE_MAP: Record<string, string> = {
  '/api-penetration-testing': 'Penetration Testing',
  '/cloud-penetration-testing': 'Penetration Testin',
  '/enterprise-penetration-testing': 'Penetration Testing',
  '/incident-response': 'Cyber Incident Response',
  '/leadership': 'Penetration Testing',
  '/managed-siem': 'Penetration Testing',
  '/network-penetration-testing': 'Penetration Testing',
  '/partners': 'Partners',
  '/pen-testing': 'Penetration Testing',
  '/penetration-testing-service': 'Penetration Testing',
  '/penetration-testing-services': 'Penetration Testing',
  '/penetration-testing': 'Penetration Testing',
  '/soc-compliance': 'Other Compliance (PCI DSS, ISO27001)',
  '/social-engineering': 'Penetration Testing',
  '/web-application-engineering': 'Penetration Testing',
  '/wireless-penetration-testing': 'Penetration Testing',
  // Add more manual mappings as needed
};

// Helper function to generate service from pathname
export const generateServiceFromPathname = (pathname: string): string | null => {
  // Remove leading and trailing slashes
  const cleanPath = pathname.replace(/^\/|\/$/g, '');

  // First check if there's a manual mapping
  if (pathname in PATH_TO_SERVICE_MAP) {
    return PATH_TO_SERVICE_MAP[pathname];
  }

  // If path contains a valid service name, use it directly
  const pathService = cleanPath
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  return pathService;
};


export const REQUIRED_SERVICE = [
  "Penetration Testing",
  "Vulnerability Scanning",
  "Managed SIEM",
  "DDoS Mitigation",
  "GDPR Compliance",
  "Outsourced DPO",
  "Other Compliance (PCI DSS, ISO27001)",
  "Partners",
  "Virtual Security Manager",
  "Cyber Incident Response",
  "Training",
  "Other"
] as const;

export const shouldShowServiceDropdown = (pathname: string): boolean => {
  // Show dropdown if there's no manual mapping
  const hasManualMapping = pathname in PATH_TO_SERVICE_MAP;
  return !hasManualMapping;
};
